import request from '@/utils/request'
import axios from 'axios'

// 登录接口
export function login (data) {
  return axios({
    url: process.env.BASE_URL + '/ordering_system_mobile/userinfo/PhoneNumberLoginOrRegiste',
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data: {
      'data': JSON.stringify(data)
    }
  })
}

// 注册接口 - 收集信息
export function reg (data) {
  return axios({
    url: process.env.BASE_URL + '/ordering_system_mobile/userinfo/PhoneNumberLoginOrRegisteByAllInfo',
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data: {
      'data': JSON.stringify(data)
    }
  })
}

// 获取验证码
export function getCode (data) {
  return axios({
    url: process.env.BASE_URL + '/ordering_system_mobile/userinfo/RequestPhoneCode',
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data: {
      'data': JSON.stringify({
        ...data
      })
    }
  })
}

// 获取报名登录图片、商品列表页入口图片、活动介绍入口图、活动介绍详情url
export function getLoginImage (data) {
  return axios({
    url: process.env.BASE_URL + '/ordering_system_mobile/conferenceimage/getLoginImage',
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data: {
      'data': JSON.stringify({
        ...data
      })
    }
  })
}

// 验证token是否失效
export function checkToken () {
  return request({
    url: '/ordering_system_mobile/usertoken/checkToken',
    // headers: {
    //   'Content-Type': 'application/json'
    //   // 'token': token
    // },
    method: 'post'
    // data: {
    //   'data': JSON.stringify({
    //     token
    //   })
    // }
  })
}

// export function getInfo(token) {
//   return request({
//     url: '/user/info',
//     method: 'get',
//     params: { token }
//   })
// }

// export function logout() {
//   return request({
//     url: '/user/logout',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/login.js